export default {
    name: 'CiResourceHeaderSkeletonLoader'
};
